export const loaderAction = (state = false, action) => {
  switch (action.type) {
    case "LOAD_STATE":
      return action.data;

    default:
      return state;
  }
};
